import { useState } from "react";
import { instagramPhotos } from "../../data/content";

const FooterBanner = () => {
  const [activePhoto, setActivePhoto] = useState(null);

  const handleClick = (photo) => {
    setActivePhoto((prev) => (prev === photo ? null : photo));
  };

  return (
    <div className="relative mb-32 flex flex-col items-center justify-center rounded-3xl p-10 shadow-2xl dark2 rounded rounded-xl"
    >
      <div className="relative z-10 text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 mt-10 mb-10">📸 ¡Seguinos en Instagram!</h2>
        <a
          href="http://www.instagram.com/capacut3d?igsh=MTRuN3M2eWNrMmlwbA=="
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold py-3 px-6 rounded-full"
          style={{ backgroundColor: "white", color: "black" }}
        >
          Visitar Perfil
        </a>
      </div>
      <div className="p-2 mb-10">
        <div className="relative p-2 z-10 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl">
          {instagramPhotos.slice(0, 8).map((ig) => (
            <div
              key={ig.img}
              className="relative w-full aspect-square rounded-xl overflow-hidden cursor-pointer group"
              style={{ borderWidth: "2px", borderColor: "rgb(238 238 238)!important" }}
              onClick={() => handleClick(ig.img)}
            >
              <img
                src={ig.img || "/loading.webp"}
                alt="instagram"
                className="w-full h-full object-cover object-center transform group-hover:scale-110 transition-transform duration-500"
              />
              {activePhoto === ig.img && (
                <div className="absolute inset-0 flex items-center justify-center bg-black text-white text-lg text-center px-4" style={{ opacity: 0.84 }}>
                  <p style={{ whiteSpace: 'pre-line', fontSize: '0.9rem' }} >{ig.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterBanner;